export default __webpack_public_path__ + "locales/tr/ResetApplicationDialog.json?hash=a2fe3e5c11a5cbb2e24b27ae3e4b8913";